import * as React from 'react';
import * as PropTypes from 'prop-types';
import Modal from '@reverbdotcom/commons/dist/components/modal';

class BumpModal extends React.Component {
  constructor(props) {
    super();
    this.state = {
      modalOpen: props.modalOpen,
    };

    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    return (
      <Modal
        isOpen={this.state.modalOpen}
        headerTitle={I18n.t('js.bump.modal.title')}
        onRequestClose={this.closeModal}
        subClass="bump-modal"
        shouldCloseOnOverlayClick
        newClose
      >
        <div className="padding-3 pt-4">
          {this.props.children}
        </div>
      </Modal>
    );
  }
}

BumpModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
};

export default BumpModal;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_modal.jsx